// Globals
import React, { useMemo } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

// Components
import { StyledSwitchButton, StyledTabs, StyledLabel } from './TabsStyles';
import { ROUTES } from '@/models/router.model';

interface ITabsConfig {
  label: string | JSX.Element;
  key: string;
}

interface ITabs {
  config: ITabsConfig[];
}

const Tabs = ({ config }: ITabs) => {
  const { type } = useParams<{ type: string }>();
  const navigate = useNavigate();

  const tabsItems = useMemo(
    () =>
      config?.map((item) => {
        const handleClick = () => navigate(`${ROUTES.USERS_LIST_INDEX}/${item.key}`);

        return (
          <StyledSwitchButton key={item.key} $isActive={type === item.key} onClick={handleClick}>
            <StyledLabel>{item.label}</StyledLabel>
          </StyledSwitchButton>
        );
      }),
    [config, type, navigate],
  );

  return <StyledTabs>{tabsItems}</StyledTabs>;
};

export default Tabs;
